import styled from 'styled-components';
import { ACTIVE_LUMINANCE, HOVER_LUMINANCE } from "../../constants";
import { changeRgbLuminance } from "../../utils/changeRgbLuminance";
export const SelectItemContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;

  background-color: ${_ref => {
  let {
    theme,
    selected,
    highlighted
  } = _ref;
  if (selected) {
    return theme.colors.secondaryL3;
  }
  if (highlighted) {
    return changeRgbLuminance(theme.colors.secondary, ACTIVE_LUMINANCE);
  }
  return theme.colors.secondary;
}};

  padding: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === 'md' ? '14px' : size === 'sm' ? '2px 14px' : '18px 14px';
}};
  min-height: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === 'md' ? '48px' : size === 'sm' ? '40px' : '64px';
}};
  cursor: pointer;

  &:hover {
    background-color: ${_ref4 => {
  let {
    theme,
    selected
  } = _ref4;
  return selected ? changeRgbLuminance(theme.colors.secondaryL3, HOVER_LUMINANCE) : changeRgbLuminance(theme.colors.secondary, HOVER_LUMINANCE);
}};
  }

  &:active {
    background-color: ${_ref5 => {
  let {
    theme,
    selected
  } = _ref5;
  return selected ? changeRgbLuminance(theme.colors.secondaryL3, ACTIVE_LUMINANCE) : changeRgbLuminance(theme.colors.secondary, ACTIVE_LUMINANCE);
}};
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  overflow: hidden;
`;
export const Label = styled.span`
  ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.fonts.infoLG;
}}
  color: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.neutralL5;
}};
  display: block;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const Description = styled.span`
  ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.fonts.infoXS;
}}
  color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.secondaryL3;
}};
  display: block;
  user-select: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const DecoratorBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;